
function pageHeader() {
 
  var directive = {
    template: require('./lloyds.pageHeader.html'),
    controller: PageHeaderController,
    controllerAs: 'pageHeaderController',
    bindToController: true
  };

  function PageHeaderController($scope, coreService) {
	var vm = this;
	vm.baseUri = "https://commercialbanking.lloydsbank.com";
    var model = coreService.getIdentityModel();
	if (model && model.custom)
	{ 
	vm.baseUri = model.custom.api_base;		
	}  
  }
  return directive;
};
export default pageHeader;


// WEBPACK FOOTER //
// ./src/login/header/lloyds.pageHeader.js